// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1pVZE","title":"Info_title__2BehR","links":"Info_links__dhFXE","link":"Info_link__2g3fy","logo":"Info_logo__2AXID"};